export default {
  "startGenerating": "Start Generating",
  "cancel": "Cancel",
  "helpMeWriteIt": "Write:",
  "pleaseSelectLevelOne": "Please select a category",
  "feedbackFilteringBar": "Filter criteria",
  "determine": "Confirm",
  "reportSendingLost": "Report sending failed: {val1}",
  "reportSentAs": "Report sent successfully",
  "theReportContentIsNot": "Report content cannot be empty",
  "pleaseEnterRequiredField": "Please enter required fields",
  "pleaseEnterYourEmailAddress": "Enter email addresses separated by semicolons (max 30)",
  "mailRecipient": "Recipients (default: yourself)",
  "pleaseEnterToSend": "Enter email title",
  "emailTitle": "Email Title",
  "emailPushReport": "Email report settings",
  "helpMeWriteIt2": "Write",
  "inputTriggers": "Type \"/\" to invoke",
  "emailPush": "Email push",
  "editFeedbackScore": "Edit report",
  "reset": "Reset",
  "hCent": "<h1 {val1}>【{val2}】-AI Analysis Report✍️</h1><p {val3}>(Statistical Period: {val4} ~ {val5}   Creator: {val6})  </p><a href='{val7}?ref=aiReport' target=\"_blank\">View AI report data source</a> 🙌<br/>",
  "store": "{val1} - AI Analysis Report (Statistical Period: {val2} ~ {val3})✍️",
  "generateReport": "Report",
  "setOtherScreens": "Set other filters",
  "defaultFilterBar": "Default filters same as overview homepage",
  "youHaveSelectedAs": "Confirm to generate report with selected filters?",
  "typicalUserFeedback": "User feedback extraction",
  "specifyCategoryReverse": "Category analysis",
  "overallFeedbackTrend": "Overall trend",
  "feedbackAnalysisSummary": "Summary",
  "lag": "5. Lagging",
  "whenBindingAnAccount": "4. Unable to receive SMS verification code when binding account. This issue has persisted, suspected account risk.",
  "afterPurchasingAtThatTime": "3. Did not receive badge after purchasing.",
  "itsAllAdvertisements": "2. All ads, even with membership still ads, will not use it again. Very disappointed.",
  "taskLeader": "1. Task opportunity draw card has never occurred before, today while doing tasks, tasks could not be refreshed.",
  "aiAutomatically": "AI extracts ≤20 user feedback.",
  "extractTheMostRange": "Extraction range (up to 2 categories):",
  "feedbackQuantityTo": "Top 5 feedback volume issues: Membership auto-renewal closure, system message notifications repeated push, prolonged loading on login homepage, order data download failure, WeChat binding QR code issues.\n                  Volume increase ranking: Help and feedback settings not displayed, homepage refresh multiple times, account exit anomaly.",
  "specifyTheMostSuitableCategory": "Specify category (up to 2 categories):",
  "generatingResults": "Result range: Month-on-month trend and changes",
  "duplicateAccountLogin": "5. Account duplicate login banned 367 pieces (6.3%) 2277.0%↑",
  "qqLoginIsBlocked": "4. QQ login blocked by system manager 252 pieces (5.9%) 304.0%↑",
  "directWithoutNetwork": "3. Direct white screen with no prompt when offline 121 pieces (2.8%) 350.0%↑",
  "fullScreenClick": "2. Full-screen click on download button unresponsive 130 pieces (3.0%) 398.5%↑",
  "pointsAcquisitionAnd": "1. Points acquisition and redemption issues 144 pieces (3.2%) 400.1%↑",
  "soaringProblem": "【Soaring Issues】",
  "aHistoricalCycle": "Feedback volume trend over time (incl. current)",
  "pleaseEnter": "Enter 5 to 20",
  "generateCycleRange": "Cycle range: Recent",
  "generateContentDisplay": "Example",
  "feedbackTime": "Feedback time",
  "replyTime": "Reply time",
  "reportGenerated": "Report done",
  "typicalUserZhen": "User selection done",
  "classificationFeedback": "Analysis done",
  "summaryOfFeedback": "Summary done",
  "feedbackTrend": "Trend done",
  "feedbackDataScreening": "Screening done",
  "reportGenerationInProgress": "Generating report...",
  "typicalUserZhen2": "Selecting users...",
  "classificationFeedback2": "Analyzing...",
  "summaryOfFeedback2": "Generating summary...",
  "feedbackTrend2": "Summarizing trends...",
  "feedbackDataScreening2": "Screening data...",
  "customInformation": "Custom information",
  "applicationVersion": "Version",
  "feedbackVersionSelection": "Version",
  "feedbackSourceSelection": "Source",
  "feedbackTypeSelection": "Type",
  "allCategories": "All",
  "systemInformation": "System information",
  "pleaseChooseFi": "Please choose {val1}",
  "pleaseEnterFi": "Please enter {val1}",
  "multipleKeywords": "Use prompts for multiple keyword searches",
  "multipleKeywords2": "Separate keywords with spaces or commas",
  "feedbackContent": "Feedback content",
  "multipleSeparatedBy": "Separate with commas",
  "pleaseEnterTheContent": "Enter content...",
  "picture": "Picture",
  "alignment": "Alignment",
  "millionInvestmentRatio": "Investment ratio",
  "feedbackNumber": "Number of feedback",
  "feedbackQuantity": "Fb volume",
  "timeFormatError": "Time format error",
  "forma": "{val1} (Week {val2})",
  "expandInformation": "Expand",
  "totalProportion": "Total proportion",
  "doNotDisplayNullValues": "Filter null values",
  "urbanDistributionN": "Top 10 Cities",
  "provinceDistributionN": "Top 10 Provinces",
  "equipmentModelClassification": "Top 10 Device Models",
  "equipmentManufacturersAreDividedInto": "Top 10 Manufacturers",
  "feedbackDetails": "Feedback analysis",
  "aSource": "Source",
  "feedbackSourcesAreDividedInto": "Source distribution",
  "defaultSource": "Default source",
  "feedbackAnalysisSmall": "Analysis summary",
  "province": "Province",
  "equipmentModel": "Device model",
  "versionInformation": "Version information",
  "feedbackSource": "Feedback source",
  "feedbackChannel": "Feedback channel",
  "feedbackContent2": "Feedback content (secondary)",
  "strip": " ",
  "dailyFeedbackVolume": "Daily highest ({val1})",
  "empty": "<Empty>",
  "topLi": "{val1} proportion ({val2})",
  "unitM": "{val1} total ({val2}%)",
  "focusedOn": "Focused on",
  "itemt": "【{val1}】↑ {val2}",
  "increaseInPrice": "Increase",
  "individual": "Individual",
  "aProvince": "Province",
  "class": "Class",
  "comparedToThePreviousDayOnAMonthOnMonthBasis": "vs. previous day",
  "pleaseChooseFi2": "Please choose {val1}",
  "pleaseEnterFi2": "Please enter {val1}",
  "feedbackType": "Feedback type",
  "intelligentClassification": "Fb. Class.",
  "modificationFailedE": "Modification failed: {val1}",
  "setFeedbackWords": "Settings saved",
  "curTa": "{val1} trend analysis",
  "curTa2": "{val1} statistics",
  "parameterSettings": "Settings",
  "classification": "Classification",
  "fileN": "{val1} trend statistics.xlsx",
  "date": "Date",
  "noDataAvailableAtTheMoment": "No data available",
  "getFieldOutput": "Error getting field output",
  "monthOnMonthFluctuations": "Monthly fluctuations",
  "feedbackProportion": "Proportion",
  "fieldValue": "Field value",
  "serialNumber": "No.",
  "intel": "{val1} secondary feedback volume",
  "thereAreCurrentlyNoTrendNumbersAvailable": "No trend data available",
  "intel2": "{val1} trend analysis",
  "startNow": "Start now",
  "proportionOfFeedbackVolume": "Feedback ratio",
  "feedbackPercentage": "Feedback person proportion",
  "descendingOrder": "Order",
  "ascendingOrder": "Asc",
  "feedbackClassificationSystem": "Classification: Primary",
  "proportion": "Percent",
  "title": "Title",
  "feedbackTypeClassification": "Type distribution",
  "correspondingToTheSelectedTime": "Alarm count change vs. previous period",
  "numberOfAlarms": "Alarm count",
  "convertToOnca": "Convert to on-call",
  "replyQuantityReversed": "(Replied / Total) * 100%",
  "responseRate": "Response rate",
  "replyReceived": "Replied",
  "turnedTapd": "Turned to TAPD",
  "correspondingToTheSelectedTime2": "Daily average feedback persons",
  "dailyAverageNumberOfPeople": "Daily average",
  "dailyAverageFeedbackVolume": "Daily average volume",
  "correspondingToTheSelectedTime3": "Volume change vs. previous period",
  "analysis": "Analysis",
  "totalFeedbackAmount": "Total",
  "inStatisticalAnalysis": "Import DAU data in statistics/report config to update investment ratio values.",
  "correspondingToTheSelectedTime4": "Feedback persons change vs. previous period",
  "fileT": "{val1} trend statistics.xlsx",
  "problemDetails": "Problem details",
  "goToUserVoice": "View More",
  "getDetailsLost": "Failed to get details",
  "lastNDaysOfWeek": "(Recent trend: N days/week/month)",
  "theFeedbackClassificationIs": "Feedback classification is required for AI reports. Please enable the classification model first.",
  "goAheadAndActivateIt": "Activate now",
  "wantToSeeMore": "View more data in Aisee>",
  "viewFilm": "View {val1} filters",
  "feedbackTimeF": "Feedback time {val1}- {val2}",
  "feedbackTrend3": "Feedback trend",
  "addNewHotspots": "Add hotspots",
  "soaringList": "Soaring List",
  "aiSee": "AiSee User Feedback Overview",
  "theSelectedConditions": "Selected feedback triggered alarms, corresponding to generated issues",
  "alarmTransferOrder": "Alarm transfer order",
  "feedbackProcessingStatus": "Status is not \"new feedback\"",
  "followedUp": "Followed up",
  "feedbackHandlingSituation": "Processing status",
  "numberOfProblemsHandled": "(Handled / Total) * 100%",
  "processedMa": "Processed {val1}",
  "theSelectedConditions2": "Selected feedback manually converted to questions",
  "aiCustomerServiceLevel": "AI resolved issues without manual intervention",
  "resolutionRate": "Solution rate:",
  "activateNow": "Activate now",
  "contactAiS": "Contact AiSee Assistant",
  "usuallyAiS": "AiSee assistant answer rate typically exceeds 70%",
  "aiCustomerServiceMeeting": "AI service session",
  "relatedProblemColumn": "Related Issues",
  "problemStatusSystem": "Problem status",
  "processingRate": "Processing rate",
  "processedCompleted": "Completed: status \"New Issue\" or \"Under Follow up\"",
  "unfinishedQuestions": "Unfinished: status \"new issue\" or \"under follow-up\"",
  "feedbackManualConversion": "Manual conversion statistics",
  "title2": "{val1} (Abandoned)",
  "negotiatedAndResolved": "Problem resolved through negotiation",
  "issueResolved": "Issue resolved",
  "issuePending": "Issue pending",
  "relatedProblemHand": "Related issues (manual conversion)",
  "invalidIssue": "Invalid issue",
  "overviewHomepage": "Overview",
  "userVoiceFrom": "User voice summary results available 10-15 minutes after importing new data",
  "noDataAvailablePlease": "No data available, please contact assistant"
}